module.exports = __webpack_public_path__ + "img/uatp.6c06678e.svg";